import * as React from 'react';
import { ActiveReportsTypes, UserSystemGroup } from 'store/storeTypes';
import { Box } from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { ReactComponent as FabricIcon } from 'assets/icons/fabricIcon.svg';
import { ReactComponent as TshirtIcon } from 'assets/icons/tshirtIcon.svg';
import { ReactComponent as RocketIcon } from 'assets/icons/rocketIcon.svg';
import { PbiFilterSystemGroupProps } from './PbiFilterSystemGroupContainer';
import { KonnectAnalytics } from 'KonnectAnalytics/konnectAnalytics';
import { makeTreeData } from 'components/_common/TreeSelect/treeHelpers';
import { pbiFilterSystemGroupStyles } from './PbiFilterSystemGroup.styles';

export default function PbiFilterSystemGroup(props: PbiFilterSystemGroupProps) {
  const {
    setSystemGroup,
    setFilterSystemsState,
    selectedSystemGroup,
    currentActiveReport,
    importedTenantId,
    tenantName,
    filterData,
    userSystemGroup,
  } = props;
  const handleChangeDashboard = (
    event: React.MouseEvent<HTMLElement>,
    newDashboard: UserSystemGroup
  ) => {
    if (selectedSystemGroup !== newDashboard && newDashboard !== null) {
      KonnectAnalytics.changeSystemGroupFilter('ChangeSystemGroupFilter', {
        element_id: `system-group-${newDashboard}-button`,
        interaction_type: 'click',
        systemGroupFrom: selectedSystemGroup,
        systemGroupTo: newDashboard,
        currentActiveReport,
        tenantName,
        importedTenantId,
      });
      setSystemGroup(newDashboard);
      const allSystemsSelected = makeTreeData({
        rootElements: filterData[newDashboard].sites,
        parentElements: filterData[newDashboard].models.map(m => ({
          id: m.id,
          name: m.name,
          rootId: m.siteId,
        })),
        childElements: filterData[newDashboard].systems.map(s => ({
          id: s.name,
          name: s.name,
          rootId: s.siteId,
          parentId: s.modelId,
        })),
        rootSelectedIds: filterData[newDashboard].sites.map(site => site.id),
        parentSelectedIds: filterData[newDashboard].models.map(model => model.id),
        childSelectedIds: filterData[newDashboard].systems.map(system => system.name),

        enableLowLevelSelect: true,
      });
      setFilterSystemsState(allSystemsSelected);
    }
  };
  return (
    <ToggleButtonGroup
      exclusive
      value={selectedSystemGroup}
      onChange={handleChangeDashboard}
      sx={pbiFilterSystemGroupStyles.toggleButtonGroup}>
      {userSystemGroup.includes('Apollo') && (
        <ToggleButton value={UserSystemGroup.Apollo} data-testid="system-group-Apollo-button">
          <RocketIcon width={20} height={18} />
        </ToggleButton>
      )}
      {userSystemGroup.includes('DTG') && (
        <ToggleButton value={UserSystemGroup.DTG} data-testid="system-group-DTG-button">
          <TshirtIcon width={25} height={25} />
        </ToggleButton>
      )}
      {userSystemGroup.includes('DTF') && (
        <ToggleButton value={UserSystemGroup.DTF} data-testid="system-group-DTF-button">
          <FabricIcon width={25} height={25} />
        </ToggleButton>
      )}
    </ToggleButtonGroup>
  );
}
